import React from 'react';
import { Stack, Form } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import UploadFile from '../../../../../components/UploadFile';
import { Attachments } from './components/Attachments';

export type StepReasonFilesProps = {
  reason: string;
  setReason: (reason: string) => void;
  selectedFiles: File[];
  setSelectedFiles: (files: File[]) => void;
  isReasonMandatory: boolean;
};

export const StepReasonFiles: React.FC<StepReasonFilesProps> = ({
  reason,
  setReason,
  selectedFiles,
  setSelectedFiles,
  isReasonMandatory,
}) => {
  const t = useNamespacedTranslation('changeRequests.requestForm');

  return (
    <Stack gap={3}>
      <div>
        <Form.Group>
          <Form.Label>
            {t('reason.label')}
            {isReasonMandatory && <span className="text-danger"> *</span>}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t('reason.placeholder')}
            required={isReasonMandatory}
          />
        </Form.Group>
      </div>

      <div>
        <Form.Label>{t('attachments.label')}</Form.Label>
        <UploadFile
          multiple
          acceptExtensions=".jpg,.jpeg,.png,.pdf,.txt"
          onChange={(files: FileList) =>
            setSelectedFiles([...selectedFiles, ...Array.from(files)])
          }
        />
        <Attachments
          files={selectedFiles}
          onChange={(files: File[]) => setSelectedFiles(files)}
        />
      </div>
    </Stack>
  );
};
